var _style, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#21486B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.2,200H67.1V80.6h21.2V200L88.2,200z M104.4,161.5V200h-3.7V49.5h49.8V200H148v-38.6H104.4L104.4,161.5z  M135.5,200h-18.7v-26.1h18.7V200L135.5,200z M185.3,200h-22.4V80.6h22.4V200L185.3,200z M197.7,200V74.4c0-3.7-2.5-6.2-6.2-6.2 h-28.6V43.3c0-3.7-2.5-6.2-6.2-6.2H93.2c-3.7,0-6.2,2.5-6.2,6.2v24.9H58.4c-3.7,0-6.2,2.5-6.2,6.2V200H41v12.4h168V200L197.7,200 L197.7,200z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.9,55.7 120.6,55.7 120.6,146.5 106.9,146.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.5,55.7 143,55.7 143,146.5 130.5,146.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.4,83.1 182.8,83.1 182.8,95.5 165.4,95.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.4,103 182.8,103 182.8,115.4 165.4,115.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.4,121.6 182.8,121.6 182.8,135.3 165.4,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.4,141.5 182.8,141.5 182.8,154 165.4,154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.4,161.5 182.8,161.5 182.8,173.9 165.4,173.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3,83.1 84.5,83.1 84.5,95.5 68.3,95.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3,103 84.5,103 84.5,115.4 68.3,115.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3,121.6 84.5,121.6 84.5,135.3 68.3,135.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3,141.5 84.5,141.5 84.5,154 68.3,154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.3,161.5 84.5,161.5 84.5,173.9 68.3,173.9  "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.5,161.6c0.5,5.4,5,9.5,10.5,9.5c5.2,0,9.5-4.2,9.5-9.5v-0.1V41.1c0-21.2-17.1-38.6-38.2-38.6H41.1 C20,2.5,2.6,19.9,2.5,41.1v168.1c0.1,21.2,17.5,38.3,38.6,38.3h167.5c21.1,0,38.2-17.2,38.4-38.3c-0.5-5.3-5.2-9.1-10.5-8.5 c-4.5,0.5-8.1,4-8.5,8.5c0,10.5-8.5,19.1-19,19.1H40.8c-10.5,0-19-8.5-19-19.1V98.8V79.8V41c0-10.5,8.5-19,19-19h168.1 c10.4,0.3,18.7,8.7,18.7,19.2L227.5,161.6L227.5,161.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.0ed6656d.svg";
export { ForwardRef as ReactComponent };